interface ModelAttributes {
  title: string;
  innerTitle: string;
  mobileWidth?: string | null;
  tabletWidth?: string | null;
  desktopWidth?: string | null;
  width?: string | null;
  backgroundColor: string;
  border: string;
  fullWidth?: boolean;
  name: string;
  brandModulePadding?: string | null;
  hasBorder?: boolean;
  collapsed?: boolean;
  view?: string;
}

const buildClassNameToParameterConditionMap = (model: ModelAttributes) => ({
  fullScreenWidth: model.fullWidth,
  whiteBackground: model.backgroundColor === "white",
  "region-bottom-border": model.border === "bottom",
  "l-x-padding-three xl-x-padding-three all-y-padding-six": model.name === "dx-main-content",
  "all-b-padding-six": model.name === "dx-sidebar-content",
  dxPageContent: model.name === "dx-page-content",
  "region-without-border": model.border && model.border.includes("none"),
  "bex-homepage-module": model.brandModulePadding && model.brandModulePadding === "bex_padding",
  "comet-homepage-module": model.brandModulePadding && model.brandModulePadding === "comet_padding",
});

export const getExtraClassNameBasedOnParameters = (model: ModelAttributes) => {
  const classMap = buildClassNameToParameterConditionMap(model);

  return Object.keys(classMap)
    .filter((x) => classMap[x])
    .join(" ");
};
